// extracted by mini-css-extract-plugin
export default {"modal":"dashboardModal_modal__w0-9N"};